import { useEffect, useRef } from 'react'

function useModalClose(closeModal: () => void) {
  const ref = useRef<HTMLElement | null>(null)

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      const target = event.target as Node
      if (ref.current && !ref.current.contains(target)) {
        closeModal()
      }
    }

    function handleEscapeKey(event: KeyboardEvent) {
      if (event.key !== 'Escape') return
      if (document.querySelector('[data-honest-select-open="true"]')) return
      closeModal()
    }

    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('keydown', handleEscapeKey)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleEscapeKey)
    }
  }, [closeModal])

  return ref
}

export default useModalClose
